import { VueConstructor } from 'vue';
// eslint-disable-next-line import/no-duplicates
import { AxiosInstance } from 'axios';
// eslint-disable-next-line import/no-duplicates
import axios from 'axios';
import qs from 'qs';
import { CoreOptions } from '../../index';

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosInstance
  }
  // eslint-disable-next-line no-shadow
  interface VueConstructor {
    $axios: AxiosInstance
  }
}

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    Vue.$axios = axios.create({
      // Axios sends arrays within the query in the wrong format otherwise
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    Vue.prototype.$axios = Vue.$axios;
  },
};
